var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountNotFoundRibbon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 416.28 78.5301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_auth_ribbon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04 33.8801L35 22V67L4 69.5301L19.99 52.5901L9.04 33.8801Z",
    fill: "url(#paint0_linear_auth)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.24 33.88L381 21.5V67.18L412.28 69.53L396.29 52.59L407.24 33.88Z",
    fill: "url(#paint1_linear_auth)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 59C381 59 379.367 50.7003 361.091 50.7003H52.9731C39.5 50.7003 35 58 35 58V18C35.0026 13.3095 35.8549 8.49405 39.1495 5.17833C42.4441 1.86261 46.9115 0 51.5695 0L363.44 0C368.098 0 372.564 1.86293 375.857 5.17894C379.15 8.49495 381 12.9924 381 17.682V59Z",
    fill: "url(#paint2_linear_auth)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_auth_ribbon",
    x: 0,
    y: 0,
    width: 416.28,
    height: 78.5301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_auth",
    x1: 4,
    y1: 45.765,
    x2: 35,
    y2: 45.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120133,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312452,
    stopColor: "#b51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524002,
    stopColor: "#c41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701897,
    stopColor: "#a61010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884637,
    stopColor: "#990000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_auth",
    x1: 381,
    y1: 45.515,
    x2: 412.28,
    y2: 45.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115363,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298103,
    stopColor: "#a61010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475998,
    stopColor: "#c41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687548,
    stopColor: "#b51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879867,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e81515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_auth",
    x1: 35,
    y1: 29.5,
    x2: 381,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00477979,
    stopColor: "#e81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115363,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298103,
    stopColor: "#b51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475998,
    stopColor: "#c41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687548,
    stopColor: "#b51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879867,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d31111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNotFoundRibbon);
export default __webpack_public_path__ + "static/media/account-not-found-ribbon.deb310a9242b9460bf62cb29516cc19e.svg";
export { ForwardRef as ReactComponent };